/**
 * Firma: TRX-Webdesign
 * Benutzer: Timo Gelhard
 * Datum: 06.03.2017
 * Uhrzeit: 16:05
 * Erstellt mit PhpStorm.
 */

jQuery(document).ready(function () {
    'use strict';

    /*- Navigation -----------------------------------------------------------------------*/
    (function (jQuery) {

        jQuery('.btn-navi').on('click', function () {
            jQuery('.haupt-navi > ul > li > ul').toggleClass('open');
        });

    }(jQuery));
});

